document.addEventListener("DOMContentLoaded", function(event) {
  const hcMobileTrigger = document.querySelector('.hc-mobile-trigger');
  const hcMobileClose = document.querySelector('.hc-close-trigger');
  const hcMobileMenu = document.querySelector('.hc-mobile-menu-outer');
  const hcSubmenuTrigger = document.querySelectorAll('.hc-js-toggle-submenu');
  const hcSlideSearch = document.querySelector('.hc-slide-search');
  const hcSlideClose = document.querySelector('.js-modal-close');
  const headerWrapper = document.querySelector('.header-wrapper');
  const megaDetails = document.querySelectorAll('.site-nav__item--mega .site-nav__details');
  const megaItems = document.querySelectorAll('.site-nav__item--mega');

  const hcSetMobileMenuOffset = () => {
    if (!hcMobileMenu) return;
    if (window.innerWidth > 768 || !headerWrapper) {
      hcMobileMenu.style.setProperty('--hc-mobile-menu-top-offset', '0px');
      return;
    }
    const headerBottom = Math.max(0, Math.round(headerWrapper.getBoundingClientRect().bottom));
    hcMobileMenu.style.setProperty('--hc-mobile-menu-top-offset', headerBottom + 'px');
  };
  
  hcSetMobileMenuOffset();
  window.addEventListener('resize', hcSetMobileMenuOffset);
  window.addEventListener('scroll', hcSetMobileMenuOffset, { passive: true });

  var header = document.querySelector('.header-wrapper');
  var headerAnnouncement = document.querySelector('.header-announcement');
  const isMobileMenuOpen = () => hcMobileMenu && hcMobileMenu.classList.contains('hc-mobile-menu-opened');

  function resetStickyState() {
    if (!header) return;
    header.classList.remove("hc-sticky");
    header.style.top = '';
    if (headerAnnouncement) {
      headerAnnouncement.style.position = '';
      headerAnnouncement.style.top = '';
      headerAnnouncement.style.left = '';
      headerAnnouncement.style.right = '';
      headerAnnouncement.style.zIndex = '';
    }
  }
  
  if (hcMobileTrigger) {
    hcMobileTrigger.addEventListener('click', e => {
      hcSetMobileMenuOffset();
      if (!hcMobileMenu) return;
      hcMobileMenu.classList.toggle('hc-mobile-menu-opened');
      if (isMobileMenuOpen()) {
        resetStickyState();
      }
    });
  }

  if (hcMobileClose) {
    hcMobileClose.addEventListener('click', e => {
      if (!hcMobileMenu) return;
      hcMobileMenu.classList.remove('hc-mobile-menu-opened');
    });
  }

  if (hcSlideSearch) {
    hcSlideSearch.addEventListener('click', e => {
      e.preventDefault();
      document.querySelector('#SearchModal').classList.toggle('modal--is-active');
    });
  }

  if (hcSlideClose) {
    hcSlideClose.addEventListener('click', e => {
      e.preventDefault();
      document.querySelector('#SearchModal').classList.remove('modal--is-active');
    });
  }

  hcSubmenuTrigger.forEach(function(hc_button) {
    hc_button.addEventListener('click', function() {
      const hcTarget = hc_button.getAttribute('data-target');
      const hcSubmenu = document.querySelector('.hc-slide-nav__dropdown[data-parent="'+hcTarget+'"]');
      if (!hcSubmenu) return;

      hc_button.classList.toggle('hc-clicked');
      hcSubmenu.classList.toggle('hc-submenu-opened');
    });
  });

  const syncMegaMenuState = () => {
    const megaOpen = !!document.querySelector('.site-nav__item--mega .site-nav__details[open]');
    const megaHover = !!document.querySelector('.site-nav__item--mega.is-focused, .site-nav__item--mega:hover');
    document.body.classList.toggle('hc-mega-menu-open', megaOpen || megaHover);
  };

  megaDetails.forEach(function(detailsEl) {
    detailsEl.addEventListener('toggle', syncMegaMenuState);
  });
  megaItems.forEach(function(itemEl) {
    itemEl.addEventListener('mouseenter', syncMegaMenuState);
    itemEl.addEventListener('mouseleave', syncMegaMenuState);
    itemEl.addEventListener('focusin', syncMegaMenuState);
    itemEl.addEventListener('focusout', function() {
      setTimeout(syncMegaMenuState, 0);
    });
  });
  document.addEventListener('click', syncMegaMenuState);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') syncMegaMenuState();
  });
  syncMegaMenuState();
  
  // FIXED: Calculate sticky point including announcement bar height
  var announcementHeight = headerAnnouncement ? headerAnnouncement.offsetHeight : 0;
  var sticky = announcementHeight;

  window.onscroll = function() {
    hcScroll()
  };

  function hcScroll() {
    if(window.innerWidth <= 768) {
      if (isMobileMenuOpen()) {
        resetStickyState();
        return;
      }

      if (window.pageYOffset > sticky) {
        header.classList.add("hc-sticky");
        
        if (headerAnnouncement) {
          var announcementSticky = headerAnnouncement.getAttribute('data-announcement-sticky');
          
          if (announcementSticky === 'true') {
            headerAnnouncement.style.position = 'fixed';
            headerAnnouncement.style.top = '0';
            headerAnnouncement.style.left = '0';
            headerAnnouncement.style.right = '0';
            headerAnnouncement.style.zIndex = '26';
            var announcementHeight = headerAnnouncement.offsetHeight;
            header.style.top = announcementHeight + 'px';
          } else {
            header.style.top = '0';
          }
        } else {
          header.style.top = '0';
        }
      } else {
        resetStickyState();
      }
    }
  }
  
});

/* SE - Language switcher - 19 Sep '25 */
document.addEventListener('click',function(e){
  var d=document.querySelector('.se-lang__details'); if(!d) return;
  if(!d.contains(e.target)) d.open=false;
});
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'){var d=document.querySelector('.se-lang__details'); if(d) d.open=false;}
});
